export default {
  startingout_monthly: {
    id: "price_1JDCpjEpDhzqppArFgz8OtJ1",
    name: "AC Health - Starting Out (Monthly)",
    label: "AC Health - Starting Out (Monthly)",
    price: "$5/month",
  },
  startingout_yearly: {
    id: "price_1JDCpjEpDhzqppArHFnGiClw",
    name: "AC Health - Starting Out (Yearly)",
    label: "AC Health - Starting Out (Yearly)",
    price: "$55/year",
  },
  basic_monthly: {
    id: "price_1JDCqLEpDhzqppAr1sElhC9j",
    name: "AC Health - Basic (Monthly)",
    label: "AC Health - Basic (Monthly)",
    price: "$14/month",
  },
  basic_yearly: {
    id: "price_1JDCqLEpDhzqppArWO2GrSWO",
    name: "AC Health - Basic (Yearly)",
    label: "AC Health - Basic (Yearly)",
    price: "$154/year",
  },
  professional_monthly: {
    id: "price_1JDCqyEpDhzqppAra6ElWsWy",
    name: "AC Health - Professional (Monthly)",
    label: "AC Health - Professional (Monthly)",
    price: "$29/month",
  },
  professional_yearly: {
    id: "price_1JDCqyEpDhzqppArb1cNsbOv",
    name: "AC Health - Professional (Yearly)",
    label: "AC Health - Professional (Yearly)",
    price: "$319/year",
  },
  unlimited_monthly: {
    id: "price_1JDCrbEpDhzqppAriosQ6wh5",
    name: "AC Health - Unlimited (Monthly)",
    label: "AC Health - Unlimited (Monthly)",
    price: "$45/month",
  },
  unlimited_yearly: {
    id: "price_1JDCrbEpDhzqppArH9uRefCc",
    name: "AC Health - Unlimited (Yearly)",
    label: "AC Health - Unlimited (Yearly)",
    price: "$495/year",
  },
  clinic_monthly: {
    id: "price_1JFlWAEpDhzqppArFYkeSBXv",
    name: "AC Health - Clinic (Monthly)",
    label: "AC Health - Clinic (Monthly)",
    price: "$60/month",
  },
  clinic_yearly: {
    id: "price_1JFlWBEpDhzqppAr81NUe5e6",
    name: "AC Health - Clinic (Yearly)",
    label: "AC Health - Clinic (Yearly)",
    price: "$660/year",
  },
  white_label_individual_monthly: {
    id: "price_1LzLIoEpDhzqppArWZj94JDs",
    name: "AC Health - Branded App (Monthly)",
    label: "AC Health - Branded App (Monthly)",
    price: "$150/month",
  },
  white_label_individual_yearly: {
    id: "price_1LzLIGEpDhzqppArU3O0xm4S",
    name: "AC Health - Branded App (Yearly)",
    label: "AC Health - Branded App (Yearly)",
    price: "$1800/year",
  },
  white_label_clinic_monthly: {
    id: "price_1LzM9uEpDhzqppArJOpSJ97I",
    name: "AC Health - Clinic Branded App (Monthly)",
    label: "AC Health - Clinic Branded App (Monthly)",
    price: "$199/month",
  },
  white_label_clinic_yearly: {
    id: "price_1LzMA6EpDhzqppArgWiYKIfA",
    name: "AC Health - Clinic Branded App (Yearly)",
    label: "AC Health - Clinic Branded App (Yearly)",
    price: "$2388/year",
  }
};



// WEBPACK FOOTER //
// ./src/config/subscriptionPlans.js